import React, { useState } from "react";
import { format, parse } from "date-fns";
import { CalendarDays, X } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";

const toDate = (v?: string) => (v ? parse(v, "yyyy-MM-dd", new Date()) : undefined);

export function DateField({ value, onChange, minDate, testid }: { value?: string; onChange: (v: string) => void; minDate?: string; testid: string }) {
  const [open, setOpen] = useState(false);
  const selected = toDate(value);
  const min = toDate(minDate);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <div className="relative">
        <PopoverTrigger asChild>
          <Button type="button" variant="outline" className="w-full justify-start gap-2 pr-8 font-normal" data-testid={testid}>
            <CalendarDays className="h-4 w-4 shrink-0 opacity-70" />
            <span className={selected ? "" : "text-muted-foreground"}>{selected ? format(selected, "MMM d, yyyy") : "Pick a date"}</span>
          </Button>
        </PopoverTrigger>
        {value && (
          <button type="button" aria-label="Clear date" onClick={() => onChange("")} className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-1 text-muted-foreground hover:text-foreground" data-testid={`${testid}-clear`}>
            <X className="h-3.5 w-3.5" />
          </button>
        )}
      </div>
      <PopoverContent className="w-auto p-0" align="start" data-testid={`${testid}-calendar`}>
        <Calendar
          mode="single"
          selected={selected}
          defaultMonth={selected || min}
          disabled={min ? { before: min } : undefined}
          onSelect={(d: Date | undefined) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
